<template>
    <div class="moat-application-header w-full d-flex" :class="{ 'dark': props.darkMode }">
        <div class="container w-full d-flex justify-content-between px-10">
            <div
                v-if="showLogo" 
                class="left-nav"
            >
                <router-link :to="{ name: aonLogoNamedRoute }">
                    <div class="logo mr-4">
                        <slot name="headerImage"></slot>
                        <h4 class="slab">{{ title }}</h4>
                    </div>
                </router-link>
                <nav v-if="finalLinks">
                    <router-link v-for="(navItem, index) in finalLinks" :key="`links-${index}`" :class="['link', {'router-link-active': navItem.fakeActive}]" :to="{ name: navItem.linkNamedRoute }">
                        <p>{{ navItem.linkLabel }}</p>
                    </router-link>
                </nav>
            </div>
            <div
                v-else
                class="left-nav"
            >
                <h4 class="slab">{{ title }}</h4>
            </div>
            <div class="right-nav d-flex align-items-center">
                <slot name="rightAppend"></slot>
                <template
                    v-if="finalDropdowns"
                >
                    <AonDropdown
                        v-bind="$attrs"
                        v-for="(dropdown, index) in finalDropdowns"
                        :key="`dropdown-${index}`"
                        :dark-mode="props.darkMode"
                        :items="dropdown.items"
                        icon-only-dropdown
                        :ignore-preset="dropdown.ignorePreset"
                        :icon-only-dropdown-options="dropdown.iconOptions"
                        :dropdown-pos="dropdown.dropdownPos"
                        :trigger-border="dropdown.triggerBorder"
                        :border-color="dropdown.borderColor"
                        :show-drop-down-arrow="dropdown.showDropDownArrow"
                        :trigger-label="dropdown.triggerLabel ? dropdown.triggerLabel : ''"
                        @input="itemSelected"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';

import AonDropdown from '../base/forms/AonDropdown.vue';
import logoImport from '../../assets/images/moat-logo_ip-alpha_light.png?raw'

const props = defineProps({
    user: {
        type: Object,
        required: true,
    },
    showLogo: {
        type: Boolean,
        default: true
    },
    aonLogoNamedRoute: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: null
    },
    navItems: {
        type: Array,
        default: () => [
            {
                type: 'links',
                links: [
                    {
                        linkLable: 'Reports',
                        linkNamedRoute: 'Reports'
                    }
                ]
            }
        ]
    },
    darkMode: {
        type: Boolean,
        default: false
    }
})
const itemSelected = (item) => {
    emit(`event-${item.itemValue}`);
}

const finalDropdowns = computed(() => {
    return props.navItems.find(item => item.type === 'dropdowns').links
})

const finalLinks = computed(() => {
    return props.navItems.find(item => item.type === 'links').links
})

</script>

<style lang="scss" scoped>
.moat-application-header {
    height: 70px;
    background: white;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);

    &.dark {
        background: $knightsCloak;
        border-bottom: $grey03 1px solid;

        .container {
            .link {
                &:hover, &.router-link-active {
                    background-color: $grey05;

                    p {
                        color: $grey01;
                    }

                    &:after {
                        background: $gold;
                    }
                }

                &.router-link-active {
                    background-color: $knightsCloak !important;
                    p {
                        color: white;
                    }
                }

                p {
                    color: white;
                }
            }
        }
    }

    .container {

        .logo {
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: 74px;
                align-self: center;
                margin-right: 10px;
            }

            h4 {
                margin: 0 0 0 10px;
                color: $grey01;
                line-height: 24px
            }

            .line {
                width: 2px;
                height: 32px;
                background: $grey06;
            }
        }

        nav {
            display: flex;
            height: 100%;
            margin-left: auto;

            .link {
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                width: max-content;
                height: 100%;
                margin: 0;
                padding: 0 20px;
                text-align: center;
                text-decoration: none;
                line-height: 24px;
                color: $dungeonDepths;

                &:hover {
                    p {
                        color: $grey01;
                    }
                    background-color: $grey05;

                    &:after {
                        content: '';
                        display: block;
                        height: 3px;
                        width: 100%;
                        background: $gold;

                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }

                &.router-link-active {
                    p {
                        color: $tavernAle;
                    }

                    &:after {
                        content: '';
                        display: block;
                        height: 3px;
                        width: 100%;
                        background: $tavernAle;

                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    &:hover {
                        background-color: transparent;
                    }
                }
            }
        }

        .left-nav {
            display: flex;
            height: 100%;
        }

        .left-nav {
            align-items: center;

            a {
                margin: 0;
                text-decoration: none;
            }
        }

        .right-nav {
            align-items: center;

            .trigger {
                justify-content: center;
            }

            .user-name {
                margin: auto 20px;
            }

            .icon {
                font-size: 1.5em;
                color: black;
                cursor: pointer;
                margin: 0 !important
            }
        }
    }
}
</style>
